import { useEffect, useState } from "react";
import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { routes as appRoutes } from "./routes";
import { Navbar, Footer } from "./components";
import ChatAssistant from "./components/chat.assistant/chat.assistant";
import MainTabs from "./screens/Tabs.MUI/Tabs";
import { observer } from "mobx-react";
import FaqPage from "./screens/FAQ/FAQ";
import MoveIn from "./screens/MoveIn.screen/MoveIn.screen";
import Efforts from "./screens/Efforts.screen/Efforts";
import HelpCenter from "./screens/Help Center/Help";
import CollectionNetwork from "./screens/Collection network/Collection";
import Forms from "./screens/Forms/Forms";
import HappyCenter from "./screens/HappyCenter/HappyCenter";
import News from "./screens/News/News";
import NewsById from "./screens/NewsById/NewsById";
import Media from "./screens/Media/Media";
import OpenData from "./screens/openData/OpenData";
import ServiceCharges from "./screens/ServiceCharges/ServiceCharges";
import Login from "./screens/login.screen/Login";
import Complaint from "./screens/complaint/Complaint";
import MoveInRegistration from "./screens/MoveInRegistration/MoveInRegistration";
import SocialCase from "./screens/SocialCase/SocialCase";
import MoveOutTermination from "./screens/MoveoutTermination/MoveoutTermination";
import ApplyForNOCInside from "./screens/ApplyForNOCInsideNetwork/ApplyForNOC";
import LinkProperty from "./screens/LinkPropertyScreen/LinkProperty";
import DeLinkProperty from "./screens/DelinkPropertyScreen/DeLinkProperty";
import Refund from "./screens/Refund/Refund";
import PaymentPlan from "./screens/PaymentPlan/PaymentPlan";
import BookAppointment from "./screens/BookAppointment/Booking";
import ConsultationTabs from "./screens/consultation/ConsultationTabs";
import HappinessMeter from "./components/happinessmeter/happinessmeter";
import UAERedirect from "./screens/UaePassRedirection/UaePassRedirection";
// import General from "./components/Profile/stores/GeneralStore";
import generaltStore from "./stores/GeneralStore";
import User from "./stores/UserStore";
import PaymentResult from "./screens/PaymentResult/PaymentResult";
import ExternalPaymentResult from "./screens/PaymentResult/ExternalPaymentResult";
import ForgotPassword from "./screens/ForgotPassword/ForgotPassword";
import NavbarMobile from "./components/navbar/NavbarMobile";
import { ToastContainer } from "react-toastify";
import ForgotUsername from "./screens/ForgotPassword/ForgotUsername";
import ReadSpeakerReader from "./lib/ReadSpeakerReader";
import Checkoutredirect from "./screens/CheckoutRedirect/Checkoutredirect";
import { toJS } from "mobx";
import generalStore from "./stores/GeneralStore";
import PrivateRoute from "./utils/PrivateRote";
import ResetPassword from "./screens/ResetPassword/ResetPassword";
import axios from "axios";
import VerifyEmail from "./screens/verifyEmail/VerifyEmail";
import EmailVerification from "./components/EmailVerification/EmailVerification";
import  NormalizePath from "./components/NormaliseUrlpath/NormalisePath";
import { NotifyError } from "./utils/ShowError";
import General from "./stores/GeneralStore"
import MoveoutDispute from "./screens/MoveoutDispute/MoveoutDispute";
import MoveoutDisputeDues from "./screens/MoveoutDisputeDues/MoveoutDisputeDues";
import ServiceActivation from "./screens/ServiceActivation/ServiceActivation";
import CONSTANTS from "./utils/constants";
import GatewaySelection from "./components/MoveOutTerminationTabs/GatewaySelection";



const App = observer(() => {
  const [admin, setAdmin] = useState(false);              // const [admin, setAdmin] = useState<boolean>(false);
  const [profile, setProfile] = useState(false);          // const [profile, setProfile] = useState<boolean>(false);
  const [reader, setReader] = useState(false);            // const [reader, setReader] = useState<boolean>(false);
  localStorage.setItem("color", "#101e8e");


  const getCodeLabels = async () => {
    await generaltStore.getCodeLabels();
  };

  
 
  // useEffect(()=>{
  //   setTimeout(()=>getappSetting(),7000)
  // },[])
  useEffect(() => {
    localStorage.getItem("us_tkn") ? setAdmin(true) : setAdmin(false);
    localStorage.removeItem("TabValue")
    if (User.info.personId) {
      User.getProfile(User.info.personId); //User.getProfile(User.info.personId as string);
      User.getFavourites();
    }
  }, []);
  useEffect(() => {
    getCodeLabels();
  }, []);
  useEffect(() => {
  const unverified = localStorage.getItem("uaePassUnverified");
  if (unverified) {
    NotifyError(
      General?.codeLabels['cm_acct_unverified']?.label
        ? General?.codeLabels['cm_acct_unverified']?.label
        : "Your Account Is Unverified, Please Visit the Nearest UAE PASS Kiosk"
    );

    localStorage.removeItem("uaePassUnverified");
  }
}, []);


  // define theme
  const theme = createTheme({
    palette: {
      primary: {
        light: "#FFFFFF",
        main: "#101E8E",
        // dark: "#101E8E",
        // contrastText: "#000",
      },
      secondary: {
        main: "#101E8E",
        light: "#82e9de",
        // dark: "#00867d",
        // contrastText: "#000",
      },
    },
  });

  const [isLargeScreen, setIsLargeScreen] = useState(false);

  useEffect(() => {
    function handleResize() {
      setIsLargeScreen(window.innerWidth > 991);
      generalStore?.setLargeScreen(window.innerWidth > 991);
    }
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const ColorAss = generalStore?.ColorAss;
  const contrast = generalStore?.contrast;
  const handleProfile = () => {
    setProfile(true);
  };
  const [notification, setNotification] = useState(false);
  const handleNotification = () => {
    setNotification(true);
  };
  const handleNotificationFalse = () => {
    setNotification(false);
  };

  useEffect(()=>{
    // console.log("Changed: ", ColorAss);
  },[ColorAss]);

  localStorage.setItem("ColorAss", ColorAss);

  // const [showClassicPopup, setShowClassicPopup] = useState(true);
  //  const handleSwitchToClassic = ()=> {
  //    var expiryDays = 7;
  //    var date = new Date();
  //    date.setTime(date.getTime() + (expiryDays * 24 * 60 * 60 * 1000));
  //     var expires = "expires=" + date.toUTCString();
  //     document.cookie = "useNewLogin=false; " + expires + "; path=/; domain=.ajmansewerage.ae; SameSite=Lax;";
  //     window.location.href = `${CONSTANTS?.URL?.CUSTOMER_PORTAL_OLD}`;
  //     User.logout();
  // }

  return (
    <div
      style={{
        direction:
          generaltStore?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode =="ARA"
            ? "rtl"
            : "ltr",
        backgroundColor: contrast?.contrastBackground
          ? contrast?.contrastBackground
          : "",
          '--bg-color': ColorAss ? ColorAss : 'pink',
      }}
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />

        <Box
          height="100vh"
          display="flex"
          flexDirection="column"
          minHeight={"100vh"}
        >
          <ToastContainer
            position="top-center"
            autoClose={false}
            hideProgressBar={true}
            closeOnClick={false}
            pauseOnHover={false}
            draggable={false}
          />

          <Router>
            <HappinessMeter />
            <Navbar
              handleNotification={handleNotification}
              profileClick={handleProfile}
            />

            {/* {
              isLargeScreen ? <Navbar profileClick={()=>setProfile(true)} />
              :
              <NavbarMobile  /> 
              // ''
            
            } */}

            <div style={{ flex: 1 }}>
              <NormalizePath/>

              <Routes>
                {/* {appRoutes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={<route.component />}
              />
            ))} */}
                <Route path="/" element={<Login />} />
                {/* <Route path="/dashboard" element={<MainTabs profileSet={profile} leaveProfile={() => setProfile(false)} />} /> */}
                {/* <PrivateRoute exact path="/dashboard" component={<MainTabs profileSet={profile} leaveProfile={() => setProfile(false)} />} /> */}

                <Route
                  path="/dashboard"
                  element={
                    <PrivateRoute>
                      <MainTabs
                        profileSet={profile}
                        leaveProfile={() => setProfile(false)}
                        notification={notification}
                        handleNotificationFalse={handleNotificationFalse}
                      />
                    </PrivateRoute>
                  }
                />
                <Route path="/faq" element={<FaqPage />} />

                <Route
                  path="/move-in"
                  element={
                    <PrivateRoute>
                      <MoveIn />
                    </PrivateRoute>
                  }
                />
                <Route path="/efforts" element={<Efforts />} />
                {/* <Route path="/help-center" element={<HelpCenter />} /> */}
                <Route
                  path="/collection"
                  element={
                    <PrivateRoute>
                      <CollectionNetwork />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/forms"
                  element={
                    <PrivateRoute>
                      <Forms />
                    </PrivateRoute>
                  }
                />
                <Route path="/happycenter" element={<HappyCenter />} />
                <Route path="/news" element={<News />} />
                {/* <Route path="/news/:id" element={<NewsById />} /> */}
                <Route path="/media" element={<Media />} />
                {/* <Route path="/open-data" element={<OpenData />} /> */}
                {/* <Route path="/service-charges" element={<ServiceCharges />} /> */}
                <Route path="/complaint" element={<Complaint />} />
                {/* <Route path="/Payment/CheckoutRedirect" element={<Checkoutredirect/>} /> */}

                {/* <Route path="/login" element={<Login />} /> */}
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/forgot-username" element={<ForgotUsername />} />
                <Route
                  path="/movein-registration"
                  element={<MoveInRegistration />}
                />
                <Route
                  path="/social-case-consideration"
                  element={
                    <PrivateRoute>
                      <SocialCase />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/moveout-termination"
                  element={
                    <PrivateRoute>
                      <MoveOutTermination />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/noc-apply"
                  element={
                    <PrivateRoute>
                      <ApplyForNOCInside />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/noc-apply-outside"
                  element={<ApplyForNOCInside />}
                />
                <Route path="/Service/NOCCharges/:id" element={<ApplyForNOCInside />} />
                <Route
                  path="/link-property"
                  element={
                    <PrivateRoute>
                      <LinkProperty />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/de-link-property"
                  element={
                    <PrivateRoute>
                      <DeLinkProperty />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/refund"
                  element={
                    <PrivateRoute>
                      <Refund />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/payment-plan"
                  element={
                    <PrivateRoute>
                      <PaymentPlan />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/booking"
                  element={
                      <BookAppointment />
                  }
                />
                {/* <Route
                  path="/booking"
                  element={
                    <PrivateRoute>
                      <BookAppointment />
                    </PrivateRoute>
                  }
                /> */}
                <Route
                  path="/consultation"
                  element={
                    <PrivateRoute>
                      <ConsultationTabs />
                    </PrivateRoute>
                  }
                />
                <Route path="/resetpassword" element={<ResetPassword />} />
                <Route path="/verifyemail" element={<VerifyEmail />} />
                <Route
                  path="/Payment/CheckoutRedirect"
                  element={<PaymentResult />}
                />
                <Route
                  path="/gateway"
                  element={<GatewaySelection />}
                />
                <Route
                  path="/Payment/ExternalRedirect"
                  element={<ExternalPaymentResult />}
                />
                {/* <Route path="api/payment/failure" element={<PaymentResult success={false} />} /> */}
                <Route path="/Account/UAEPassRedirect" element={<UAERedirect />} />
              
                <Route path="/Account/VerifyCode" element={<EmailVerification/>}/>
                <Route path="/moveout-dispute" element={<PrivateRoute><MoveoutDispute /></PrivateRoute>} />
                <Route path="/getdispute/:id" element={<MoveoutDisputeDues />} />
                 <Route path="/movein-service-activation" element={<ServiceActivation/>}/>

              
              </Routes>
            </div>            
            {/* <ChatAssistant /> */}
            <div style={{ marginTop: isLargeScreen ? "" : "0rem" }}>
              <Footer />
            </div>

            {/* {
              isLargeScreen ?  <Footer />
              :
             <div className=''>
               <FooterMobile />
             </div>
            } */}
          </Router>
        </Box>
      </ThemeProvider>
      {/* {showClassicPopup && User.info.userName &&(
        <div
          className="classic-popup"
          style={{
            position: "fixed",
            bottom: 18,
            right: 90,
            zIndex: 9999,
            background: "#fff",
            borderRadius: 10,
            padding: "14px 16px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            minWidth: 160,
            boxShadow: "0 2px 8px rgba(16,30,142,0.10)"
          }}
        >
          <div style={{ display: "flex", alignItems: "center", width: "100%", position: "relative" }}>
            <span style={{ fontWeight: 500, color: "#101E8E", fontSize: "0.95rem", flex: 1 }}>
              Switch to classic site
            </span>
            <button
              aria-label="Close"
              onClick={() => {
                setShowClassicPopup(false)
                
              }}
              style={{
                background: "transparent",
                border: "none",
                cursor: "pointer",
                fontSize: 18,
                color: "#101E8E",
                padding: 0,
                lineHeight: 1,
                marginLeft: 8,
              }}
            >
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M4 4l10 10M14 4L4 14" stroke="#101E8E" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
          </div>
          <button
            style={{
              background: "linear-gradient(90deg, #101E8E 60%, #4f5bd5 100%)",
              color: "#fff",
              border: "none",
              borderRadius: 5,
              padding: "6px 14px",
              fontSize: "0.95rem",
              cursor: "pointer",
              fontWeight: 500,
              boxShadow: "0 2px 8px rgba(16,30,142,0.10)",
              display: "flex",
              alignItems: "center",
              marginTop: 8
            }}
            onClick={() => {
              
            handleSwitchToClassic();

        }
            }
          >
            Click Here
            <span className="arrow-icon" style={{ marginLeft: 6 }}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M7 5l5 5-5 5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </span>
          </button>
        </div>
      )} */}
    </div>
  );
});

export default App;
